var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("g", [
    _c("path", {
      attrs: {
        d: "M49.841 53c-.86 0-1.575-.288-2.148-.862-.573-.575-.86-1.294-.86-2.157V48.4H10.167v1.581c0 .863-.287 1.581-.86 2.157-.573.575-1.289.862-2.148.862H4.008c-.86 0-1.576-.288-2.149-.862C1.286 51.563 1 50.844 1 49.98v-23L7.445 10.02C8.018 8.006 9.451 7 11.742 7h33.516c2.291 0 3.724 1.006 4.297 3.019L56 26.98v23c0 .863-.286 1.581-.86 2.157-.572.575-1.288.862-2.148.862h-3.15zM7 23h43l-4.617-13H11.617L7 23zm37.5 15c1.219 0 2.297-.422 3.234-1.266C48.578 35.891 49 34.812 49 33.5c0-1.313-.445-2.39-1.336-3.234C46.774 29.422 45.72 29 44.5 29s-2.273.422-3.164 1.266C40.446 31.109 40 32.188 40 33.5c0 1.313.445 2.39 1.336 3.234.89.844 1.945 1.266 3.164 1.266zm-34 0c1.219 0 2.297-.422 3.234-1.266C14.578 35.891 15 34.812 15 33.5c0-1.313-.445-2.39-1.336-3.234C12.774 29.422 11.72 29 10.5 29s-2.273.422-3.164 1.266C6.446 31.109 6 32.188 6 33.5c0 1.313.445 2.39 1.336 3.234C8.226 37.578 9.28 38 10.5 38z",
        fill: "currentColor",
        "fill-rule": "nonzero",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }